import { render, staticRenderFns } from "./SettingSms.vue?vue&type=template&id=c27c2af4"
import script from "./SettingSms.vue?vue&type=script&lang=js"
export * from "./SettingSms.vue?vue&type=script&lang=js"
import style0 from "./SettingSms.vue?vue&type=style&index=0&id=c27c2af4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports